import React from 'react'
import './OneColumnC.css';

const OneColumnC = ({titleOneC, titleTwoC, subtitleC, subheaderC, paragraphC}) => {
 
  return (
    <div className="app__content flex__center">
      <h1 className="headtext__roboto"> {titleOneC} </h1>
      <div className="app__content-onesectionC" >
        <h2 className="headtext__roboto"> {titleTwoC} </h2>
        <h3 className="subheadtext__roboto"> {subtitleC} </h3>
        <h4 className="h4__roboto"> {subheaderC} </h4>
        <p className="app__onesection-p p__opensans"> {paragraphC} </p>
      </div>
    </div>
  )
}

export default OneColumnC